import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { selectGeneric } from 'store/app/selectors';
import {
  selectPlansPlanPins,
  selectPlansSelectedPinId,
} from 'store/plan/selectors';
import { GENERIC_KEY_PLAN_PIN_GROUP_HIDDEN } from 'store/plan/types';

import { View } from 'react-native';
import { Pin } from './Pin';

type PinsRef = {
  scaleChange: (scale: number) => void;
  panChange: (arg: { x: number; y: number }) => void;
};

type Props = {
  width: number;
  height: number;
  onPinPress: undefined | ((id: string) => void);
  scale?: number;
  ref: React.Ref<PinsRef>;
};

export const PinsOther = ({
  height,
  onPinPress,
  width,
  scale = 1,
  ref,
}: React.PropsWithChildren<Props>) => {
  const pins = useSelector(selectPlansPlanPins);
  const hiddenPinGroups: string[] =
    (useSelector((state) =>
      selectGeneric(state, GENERIC_KEY_PLAN_PIN_GROUP_HIDDEN),
    ) as string[] | undefined) || [];
  const selectedPinId = useSelector(selectPlansSelectedPinId);

  const [internalScale, setScale] = React.useState(scale);
  const [internalPan, setPan] = React.useState({ x: 0, y: 0 });

  React.useImperativeHandle(
    ref,
    () => ({
      scaleChange: setScale,
      panChange: setPan,
    }),
    [],
  );

  const finalPins = hiddenPinGroups.length
    ? pins.filter((pin) => !hiddenPinGroups.includes(pin.group || 'Other Pins'))
    : pins;

  if (!finalPins.length) {
    return null;
  }

  const finalWidth = Math.round(width * internalScale);
  const finalHeight = Math.round(height * internalScale);

  return (
    <View
      style={{
        width: finalWidth,
        height: finalHeight,
        position: 'absolute',
        top: 'auto',
        left: 'auto',
        transform: [
          { translateY: internalPan.y * internalScale },
          { translateX: internalPan.x * internalScale },
        ],
      }}
      pointerEvents="box-none"
    >
      {finalPins.map((pin) => (
        <Pin
          key={pin.id}
          onPress={onPinPress}
          text={pin.name}
          id={pin.id}
          canvasWidth={finalWidth}
          canvasHeight={finalHeight}
          x={pin.x}
          y={pin.y}
          active={pin.id === selectedPinId}
          color={pin.color}
        />
      ))}
    </View>
  );
};
